import { DeepPartial, InstallEnergyBackupPackage } from 'types';

import { api } from './api';

export const installEnergyBackupPackageApi = api.injectEndpoints({
  endpoints: (build) => ({
    saveInstallEnergyBackupPackage: build.mutation<
      any,
      { accountId: string; savePackage: DeepPartial<InstallEnergyBackupPackage> }
    >({
      query: ({ accountId, savePackage }) => ({
        url: `v2/accounts/${accountId}/install-package/energy-backup/save`,
        method: 'POST',
        body: { ...savePackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
      ],
    }),
    submitInstallEnergyBackupPackage: build.mutation<
      any,
      { accountId: string; installPackage: InstallEnergyBackupPackage }
    >({
      query: ({ accountId, installPackage }) => ({
        url: `v2/accounts/${accountId}/install-package/energy-backup/submit`,
        method: 'POST',
        body: { ...installPackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'Queues', accountId: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
        { type: 'AccountMilestones', id: arg?.accountId },
      ],
    }),
  }),
});

export const { useSaveInstallEnergyBackupPackageMutation, useSubmitInstallEnergyBackupPackageMutation } =
  installEnergyBackupPackageApi;
